// extracted by mini-css-extract-plugin
export default {"page":"loaderPage_page__jZXF6"};